import { render, staticRenderFns } from "./RecommendListItem.vue?vue&type=template&id=a49c1684&"
import script from "./RecommendListItem.vue?vue&type=script&lang=js&"
export * from "./RecommendListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a49c1684', component.options)
    } else {
      api.reload('a49c1684', component.options)
    }
    module.hot.accept("./RecommendListItem.vue?vue&type=template&id=a49c1684&", function () {
      api.rerender('a49c1684', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/home/RecommendListItem.vue"
export default component.exports